export class SoundEffects {
  sounds: {[key: string]: HTMLAudioElement} = {};
  constructor() {
    // this.load('died');
  }

  load(key: string, file?: string): void {
    const sound = new Audio();
    sound.src = `assets/sounds/${file || key}.mp3`;
    sound.load();
    this.sounds[key] = sound;
  }

  async play(event: string): Promise<void> {
    let sound = this.sounds.tst;
    switch (event) {
      default: sound = this.sounds[event]; break;
    }
    if (!sound) { return; }
    try {
      await sound.play();
      console.log(`Sound played ${event}`);
    } catch (err) {
      switch (err.name) {
        case 'NotAllowedError':
          console.log('play inhibited ' + event);
          break;
        default:
          console.log(err);
      }
    }
  }
}
